import { GqlError } from 'utils/gql/gql.types';
import { ApolloError, isApolloError } from '@apollo/client';
import { GraphQLError, GraphQLFormattedError } from 'graphql';

export function getErrorMessage(
  e: ApolloError | GraphQLError | GraphQLFormattedError<Record<string, any>> | undefined
): { code: string; message: string } {
  if (!e) {
    return { code: '', message: '' };
  }
  if (isApolloError(e as ApolloError)) {
    const extension =
      'graphQLErrors' in e && e.graphQLErrors?.[0]?.extensions?.message
        ? e.graphQLErrors[0].extensions
        : 'graphQLErrors' in e
          ? e.graphQLErrors?.[0]
          : '';
    if (extension) {
      return {
        code: (extension as any).code,
        message: extension.message
      };
    }
  }

  if (isGqlErrorArray(e)) {
    return {
      code: e[0]?.code ?? '',
      message: e[0]?.message ?? ''
    };
  }

  return {
    code: 'DEFAULT',
    message: e.message
  };
}

export function isGqlErrorArray(errors: unknown): errors is GqlError[] {
  return typeof errors === 'object' && Array.isArray(errors);
}
